var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    iconsize: 20,
    className: "Icon-sc-1iwi4w1-0 yCMXi",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.14 11.925c-.17.188-.357.371-.552.543l-4.603 4.056-4.604-4.055a6.763 6.763 0 01-.551-9.628A6.961 6.961 0 017.987.564a6.95 6.95 0 014.601 1.733 6.739 6.739 0 012.298 4.701 6.719 6.719 0 01-1.746 4.926z",
    fill: "#FDF0E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.987 4.771a2.5 2.5 0 00-2.5 2.494 2.5 2.5 0 005 0 2.5 2.5 0 00-2.5-2.494z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.37 11.364a5.9 5.9 0 01-.47.468L7.985 15.32l-3.916-3.488a5.862 5.862 0 01-.469-8.28 5.892 5.892 0 018.3-.468 5.82 5.82 0 011.954 4.043 5.817 5.817 0 01-1.485 4.237zm.218-9.048a6.91 6.91 0 00-4.6-1.752A6.93 6.93 0 002.83 2.866 6.89 6.89 0 003.38 12.6l4.26 3.794a.515.515 0 00.688 0l4.26-3.795a6.86 6.86 0 00.55-.55 6.836 6.836 0 001.746-4.98 6.842 6.842 0 00-2.297-4.753z",
    fill: "#333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.985 8.932c-.912 0-1.654-.74-1.654-1.65a1.654 1.654 0 013.307 0c0 .91-.741 1.65-1.653 1.65zm0-4.328a2.685 2.685 0 00-2.686 2.679 2.685 2.685 0 005.371 0 2.685 2.685 0 00-2.685-2.68z",
    fill: "#333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/LocationIcon.ebfbe221a204236df68d93a6a1245cad.svg";
export { ForwardRef as ReactComponent };